import React from "react";
import { inject, observer } from "mobx-react";
import classnames from "classnames";
import TeamInfoEditForm from "./teamInfoEditForm";
import { Spin } from "antd";
import { withRouter } from "react-router-dom";

import { $util } from "../../helper";
import agent from "../../agent";

import "./stylesheets/createTeam.scss";

@inject("languageStore", "gameStore", "commonStore", "teamStore")
@withRouter
@observer
export default class TeamInfoEdit extends React.Component {
  state = {
    isLoading: true
  };

  async componentDidMount() {
    if (!this.props.match.params.id) {
      this.props.history.push("/control-center");
    } else {
      await this.props.teamStore.getTeamInfo(this.props.match.params.id);
    }
    this.setState({
      isLoading: true
    });
    await Promise.all([
      this.props.gameStore.setSelectedGame(this.props.teamStore.teamInfo.eventId),
      this.props.gameStore.getV2AllCategory(),
      this.props.commonStore.getPca()
    ]);
    const isSpecialGame = await this.judgeIsSpecialGame();
    this.props.teamStore.setCurrentTeamIsSpecialGame(isSpecialGame);

    this.setState({
      isLoading: false
    });
  }

  judgeIsSpecialGame = async () => {
    if (
      this.props.teamStore.teamInfo &&
      this.props.teamStore.teamInfo.gevent &&
      this.props.gameStore.showTeamSloganGameCategoryId &&
      this.props.gameStore.showTeamSloganGameCategoryId.length > 0
    ) {
      const eventIdOfTeam = this.props.teamStore.teamInfo.gevent.id;

      const lang = this.props.languageStore.lang;

      for (let categoryId of this.props.gameStore.showTeamSloganGameCategoryId) {
        let whileIsOk = true;
        let pageNum = 1;
        while (whileIsOk) {
          try {
            const res = await agent.Games.getV2Events(
              $util.beLangMap(lang),
              pageNum,
              50,
              categoryId
            );
            if (res && res.data && res.data.events && res.data.events.length > 0) {
              const targetGame = res.data.events.find(item => item.id === `${eventIdOfTeam}`);
              if (targetGame) {
                return true;
              }
              whileIsOk = !(targetGame || res.data.total_pages === res.data.current_page);
              pageNum++;
            } else {
              whileIsOk = false;
            }
          } catch (error) {
            whileIsOk = false;
            console.error(error);
          }
        }
      }
    }
    return false;
  };

  render() {
    if (this.state.isLoading) {
      return (
        <div className="create-team empty">
          <Spin />
        </div>
      );
    }

    if (!this.props.teamStore.teamInfo || !this.props.teamStore.teamInfo.id) {
      return <div className="create-team team-edit"></div>;
    }

    return (
      <div className={classnames("create-team team-edit", this.props.languageStore.lang)}>
        <TeamInfoEditForm
          teamInfo={this.props.teamStore.teamInfo}
          isSpecialGame={this.props.teamStore.currentTeamIsSpecialGame}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/createTeam/teamInfoEdit.js